module.exports = __webpack_public_path__ + "img/zhongshan10.5ecebd5f.jpg";